export default "__VITE_ASSET__Cwu0Pfq2__"